export default __webpack_public_path__ + "static/media/headerLogo.4d18b7af.png";